export const AiImageNSFWBlacklist = [
  'faae75cb-4c63-4672-8db4-9fb4391f49be',
  'f8d69b99-aefd-4351-8d0c-6584cf1ae88a',
  'f22a9cd4-b9a6-4cd5-b158-aa48708d00fe',
  'ed507739-ea01-4759-9370-cd6c979a4fda',
  'ec8e3037-130c-4dfa-b779-5c5df49f98b9',
  'ea3be571-bccf-487a-b495-70e8c750c8d7',
  '5afa9753-f489-4ea9-8196-c5df9a608c71',
  'e90b9dda-4fef-4e22-92e2-68f872e37404',
  'f917a388-0456-4642-acce-62f2ac735dd8',
  '65296526-e849-48fb-9a59-91b3c6951129',
  'e394b49b-ea47-49b5-855e-04720a2791db',
  'e122abc5-59cd-4fab-a701-6101912f1925',
  'dfca5d51-ea0d-4ac3-8bb1-1629661afc54',
  'dedab1ea-5ec6-4ed5-bc99-af41fcc22651',
  'de4fb0f7-6707-46d8-8d29-44d479ecf331',
  'd835f53e-ccd8-4042-8033-7d44f2f892f3',
  'd42ab00d-3d03-4b90-9557-232c3c10de61',
  'cbd790ba931d20fc0f4e50bab8d21e2578cf123e82edb891',
  'ca5dc125-b074-46bc-a734-4cc30a485ce5',
  'c72602ef-5447-4790-88a5-b809fb4c92a7',
  'c08f4c9e-f7d3-4de8-bf56-f7ca1969c75a',
  'be835b94-967d-4e75-b86a-7d5f2fc7650a',
  'baa73d20-04fd-4141-b100-88ffc17009af',
  'ba509f089f7026b18c5aed8d99001eb3526ca309997337ff',
  'b87fe28b-43eb-445e-8690-83a95f60bc41',
  'b42111a3-f7b1-41e2-b4f4-99fa4350ccd3',
  'b3f7bd2a-372e-450e-994f-ee87a0fe75cf',
  'b3bd81c6-976d-4378-a7a3-676b543c104e',
  'b38cdb4e-6e00-445b-bd65-be59f250da01',
  'b141c150-5982-4d6b-b281-5f28cc699428',
  'b0415397-e4af-4762-85ac-ae3ecdf51368',
  'a6fe62f5-2ee7-4b81-9e29-90e579bd7aea',
  'a35af652-ac64-4648-8a16-62b4988ca7a1',
  'a2fda0df-c326-4379-84bb-11ce142b55dc',
  '9cbf71d6-37eb-446f-bfee-2e0e2507a796',
  '9bc570ff-3bec-428b-9402-c2fdc83c4f7f',
  '96dc4b0f-4933-4a10-b108-785d6d9df3b7',
  '96497611-db05-42eb-8bf5-11f929ec73ca',
  '92561f00-52b9-4f95-9db8-46a6fdf183b5',
  '9146922c-c914-41a6-8db5-3fa41c50dea7',
  '8ef88125-8bcc-4147-90d8-fb430dd906a1',
  '8e9eb1b0-049f-431f-84d6-e55207df4b11',
  '7f265937-c95f-49ce-b67b-4f844d692225',
  '7ac727c9-e19b-4699-996e-f1f070ef887c',
  '715fa016-6179-493b-b357-0e6e61123fc5',
  '7123793f-1d5d-4961-8b2a-28ffb33ea1d5',
  '6c5a5ae5-c09d-4d87-b8db-c1e928f27f8d',
  '64baa19b-fb0a-48fc-90e0-2bb963b7fa80',
  '6337332c-a7ba-410c-bb99-1f7cbdc6ae78',
  '632ab109-593f-4413-b3dc-31b5056ce573',
  '623b3a0c-d3f8-48a3-91d1-f072f57ebb52',
  '608036fa-d155-4b59-a266-813fe4e6845e',
  '5f48dbde-df6f-40cb-9aa2-a0166f826ee1',
  '5f4206d9674dbd00177018445ee9c7859ee3930017157662',
  '5c3f9439-1b58-42cb-95d9-52a896cff421',
  '56280bac-a5c0-45eb-8204-d4eccff0d379',
  '5472eaa3-8ec2-4423-b1d2-edda5909596e',
  '4eb02409-6454-44fa-9730-b453e8d26fc6',
  '486211b8-e8b9-4171-9895-0696521580fc',
  '3d387f88-f994-407c-b701-63ce0628cd31',
  '3c40b6bd-1f99-43df-b7ec-daa0d0323aae',
  '3beb6a81-4186-423c-a5bb-86eb61d6a281',
  '3b6f1e80-da19-4ed1-9c64-d41a6d1c5e6a',
  '381f7c32-d575-452b-8cad-79109132f490',
  '3789e073-5fd1-4f83-bb58-e623fc816e6e',
  '3779270c-8f91-4904-8a65-766f44cd74d6',
  '35edca3f-7273-4db5-941d-3ef390696608',
  '33441ec3-e59f-4b0b-9fcf-b607bf109652',
  '29b1db9c-5047-45eb-b6f9-05ae1bdbace4',
  '26ce37b0-7320-4567-ad4f-a7ad5a0b2e4b',
  '25656c46-b086-464c-ab12-df6939d561de',
  '25103d91-c121-487a-a929-850e6e85e0cc',
  '24c2bb30-25f6-496c-b318-7e39598d7fc9',
  '20c1e113-b91f-4c1d-8c16-3f5f75e913f8',
  '152290e5-376e-4aae-ba33-2f06fd6afb77',
  '1483f2e8-5d6e-4fbe-90c4-e0b0a03f9b0a',
  '0db0c5cd-3a9a-45cc-b842-1c556c679d0a',
  '0bfac9f3-b5ae-446b-a3d2-ded3311795e9',
  '09158c9c-271d-44a5-b504-dd4e7ecc0cbd',
  '07e132ca-0d3d-4be4-828f-cddab3e3196c',
  '06c2e8cf-d404-4101-b818-0e4e7f267f39',
  '0669a960-bf5d-4f33-9b6f-351bdbbdb25b',
  '03b31041-8ba0-4397-857e-40716af8e3aa',
  '03747804-e238-4ccf-ab6f-c7a6d1e04188',
  '035d912a-9d2c-49da-8b32-fd53dea5fe57',
  '02aea54d-3e1c-42f5-a397-fa443b6379f4',
  '015cce6c-1a2a-4275-aea9-fb352acb031c',
  'b3bd81c6-976d-4378-a7a3-676b543c104e',
  '6337332c-a7ba-410c-bb99-1f7cbdc6ae78',
];
